import { useEffect, useMemo } from 'react'
import './_WriterOptions.scss'
import { useDispatch, useSelector } from 'react-redux'
import { CONSTANTS, TYPE_OPTIONS, DOC_TEMPLATES } from '../../constants'
import { selectDocumentState, setUserWriterSelections } from '../../redux/docSlice'
import Button from '../Buttons'
import { isEqual } from 'lodash'
import { DocumentState, UserWriterSelections } from '../../redux/types'
import { blankUserWriterSelections } from '../../redux/constants'
import { useFreeWordLimit } from '../../hooks/featureFlags'
import WritingStyleSelection from './WritingStyle'
import ReferencesSelection from './References'
import useIsPremium from '../../hooks/useIsPremium'

type Props = {
	type: string
	premiumUser: boolean
	formValid: boolean
	localUserWriterSelections: UserWriterSelections
	docID: string
	setSubscriptionModalOpen: (open: boolean) => void
	topicValue: string
}

function WriterOptions(props: Props) {
	const freeWordLimit = useFreeWordLimit()
	const dispatch = useDispatch()
	const documentState: DocumentState = useSelector((state) => selectDocumentState(state, props.docID))

	//Set redux if we have local storage for this document on component mount
	useEffect(() => {
		if (!isEqual(props.localUserWriterSelections, blankUserWriterSelections)) {
			dispatch(
				setUserWriterSelections({
					docID: props.docID,
					userWriterSelections: props.localUserWriterSelections,
				})
			)
		}
		//Update only on initial page load
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	const pageCount = useMemo(() => {
		const wordCount = documentState.userWriterSelections?.wordCount ?? freeWordLimit
		return (wordCount / 500).toFixed(1)
	}, [documentState.userWriterSelections?.wordCount])

	const maxWordCount = CONSTANTS.WORD_COUNT_MAX

	return (
		<>
			<div id="writerOptions">
				<div className="toneTypeContainer">
					<div className="text-xl mb-3 font-semibold text-center">Select an essay type</div>
					<div className="grid md:grid-cols-5 grid-cols-1 gap-3 toneTypeList">
						{TYPE_OPTIONS.map((str, index) => {
							return (
								<Button
									className={`toneTypeButton ${str === documentState.userWriterSelections?.type && 'selected'}`}
									key={str + index}
									type="primary"
									onClick={(e) => {
										dispatch(
											setUserWriterSelections({
												docID: props.docID,
												userWriterSelections: { type: str },
											})
										)
									}}
								>
									<span>{str}</span>
								</Button>
							)
						})}
					</div>
				</div>
				{props.type !== DOC_TEMPLATES.Outline && (
					<>
						<WritingStyleSelection docID={props.docID} />
						<ReferencesSelection docID={props.docID} />
					</>
				)}
			</div>
		</>
	)
}

export default WriterOptions
